import { render, staticRenderFns } from "./cmppedidosprodutos.vue?vue&type=template&id=8808a0a2&"
import script from "./cmppedidosprodutos.vue?vue&type=script&lang=js&"
export * from "./cmppedidosprodutos.vue?vue&type=script&lang=js&"
import style0 from "./cmppedidosprodutos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports